import axios, { API_URL } from './BaseService';

const LOGS_URL = `${API_URL}/logs/`;

export async function getLogs(file) {
    const safe = encodeURIComponent(String(file || '').replace(/^\//, ''));
    const response = await axios.get(`${LOGS_URL}${safe}`, {
        responseType: 'text',
        transformResponse: [(data) => data]
    });
    return response.data;
}

export async function getLogList({ page = 1, pageSize = 100, userId } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    if (userId != null && userId !== '') params.set('userId', String(userId));
    const response = await axios.get(`${LOGS_URL}?${params.toString()}`);
    return response.data;
}
